<template>
  <div class="container-fluid">
    <div class="row g-0">
      <div class="col">
        <button class="btn btn-back btn-outline-secondary" @click="goBack">
          Back
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-download btn-primary"
          @click="downloadReportError"
          :disabled="transferStore.loading"
        >
          Download Error Report
        </button>
        <button class="btn btn-download btn-primary" @click="downloadReportCsv" :disabled="transferStore.loading">
          Download Report Details
        </button>
        <button class="btn btn-download btn-primary" @click="downloadReportPdf" :disabled="transferStore.loading">
          Download Report Summary
        </button>
      </div>
    </div>
    <div class="row">
      <vue-good-table
        class="vue-table"
        ref="table"
        mode="remote"
        :isLoading.sync="isLoading"
        :totalRows="100"
        :rows="reportSummary"
        :columns="columns"
      >
      </vue-good-table>
    </div>
  </div>
  <manage-reports-modal />
</template>

<script setup lang="ts">
import ManageReportsModal from "@/components/Modal/ManageReportsModal.vue";
import { ExportCsv } from "@/library/ExportCsv";
import { useTransferStore } from "@/stores/content_review/transfer";
import { usePDF } from "@/stores/report_pdf";
import { useAudit } from "@/stores/audit";
import { useAsyncState } from "@vueuse/core";
import moment from "moment";
import { ref, watch } from "vue";
import { useRouter } from "vue-router";

const table = ref();
const transferStore: any = useTransferStore();
const router = useRouter();
const isLoading = ref(false);
const reportSummary: any = ref([]);
const audit = useAudit();

watch(
  () => transferStore.reportSummary,
  (updateReport) => {
    reportSummary.value.push(updateReport);
  }
);

watch(
  () => transferStore.loading,
  (updateLoading) => (isLoading.value = updateLoading)
);

const columns = [
  {
    label: "Title",
    field: function (rowObj) {
      return rowObj.title ? rowObj.title : "-";
    },
    sortable: false,
    width: "300px",
  },
  // {
  //   label: "Date Received",
  //   field: "date",
  //   formatFn: function (value) {
  //     return moment(value).format("DD MMM yyyy HH:mm:ss");
  //   },
  //   sortable: false,
  //   width: "120px",
  // },
  {
    label: "Transferring Agency",
    field: function (rowObj) {
      return rowObj.transferring_agency ? rowObj.transferring_agency : "-";
    },
    sortable: false,
    width: "180px",
  },
  {
    label: "Transfer Date",
    field: "transfer_date",
    formatFn: function (value) {
      if (!value) return "-";
      else if (moment(value).format("DD MMM yyyy") == "01 Jan 0001") return "-";
      else return moment(value).format("DD MMM yyyy");
    },
    sortable: false,
    width: "120px",
  },
  {
    label: "Transfer Batch No",
    field: function (rowObj) {
      return rowObj.transfer_batch_number ? rowObj.transfer_batch_number : "-";
    },
    sortable: false,
    width: "120px",
  },
  {
    label: "Number Of Items",
    field: function (rowObj) {
      return rowObj.number_of_items ? rowObj.number_of_items : "0";
    },
    sortable: false,
    width: "110px",
  },
  {
    label: "Number Of Computer Files Received",
    field: function (rowObj) {
      return rowObj.number_of_computer_files
        ? rowObj.number_of_computer_files
        : "0";
    },
    sortable: false,
    width: "160px",
  },
  {
    label: "Number Of Errors",
    field: function (rowObj) {
      return rowObj.number_of_errors ? rowObj.number_of_errors : "0";
    },
    sortable: false,
    width: "110px",
  },
  {
    label: "Total Size",
    field: function (rowObj) {
      if (rowObj.total_size) {
        var size = rowObj.total_size;
        if (size >= 1073741824) {
          size = (size / 1073741824).toFixed(2) + " GB";
        } else {
          size = (size / 1048576).toFixed(2) + " MB";
        }
        return size;
      } else return "-";
    },
    sortable: false,
    width: "80px",
  },
  {
    label: "Transfer Outcome",
    field: function (rowObj) {
      return rowObj.transfer_outcome ? rowObj.transfer_outcome : "-";
    },
    sortable: false,
    width: "100px",
  },
  {
    label: "Transfer ID",
    field: function (rowObj) {
      return rowObj.transfer_id ? rowObj.transfer_id : "-";
    },
    sortable: false,
    width: "200px",
  },
];

const { execute, error } = useAsyncState(() => {
  return transferStore.transferReportTable(
    router.currentRoute.value.params.selectedTransferId
  );
}, null);

const goBack = () => {
  router.push("/content");
};

const downloadReportCsv = async () => {
  await transferStore.transferReportAppendix(
    router.currentRoute.value.params.selectedTransferId
  );
};

const downloadReportPdf = async () => {
  audit.auditLog("Transfer Report Summary"),
  await transferStore.transferReportSummary(
    
    router.currentRoute.value.params.selectedTransferId
  );
};

const downloadReportError = async () => {
  await transferStore.transferReportError(
    router.currentRoute.value.params.selectedTransferId
  );
};
</script>

<style scoped>
.vue-table {
  position: relative;
  padding: 20px;
}

.btn-back {
  position: relative;
  margin: 20px;
  margin-bottom: 0;
  width: 160px;
  float: left;
}

.btn-download {
  position: relative;
  margin: 10px;
  margin-top: 20px;
  margin-bottom: 0;
  width: 200px;
  float: right;
}
</style>
